import { render, staticRenderFns } from "./TransectionTeachingDare.vue?vue&type=template&id=d5770bf2&"
import script from "./TransectionTeachingDare.vue?vue&type=script&lang=js&"
export * from "./TransectionTeachingDare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports